import { render, staticRenderFns } from "./VadiguAppointmentsView.vue?vue&type=template&id=995ae1aa&scoped=true&lang=pug"
import script from "./VadiguAppointmentsView.vue?vue&type=script&lang=js"
export * from "./VadiguAppointmentsView.vue?vue&type=script&lang=js"
import style0 from "./VadiguAppointmentsView.vue?vue&type=style&index=0&id=995ae1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995ae1aa",
  null
  
)

export default component.exports